
import { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import "./Navbar.css";

const Navbar = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [navbarMode, setNavbarMode] = useState(localStorage.getItem("navbarmode") || "hardware");
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const location = useLocation();

    // Close mobile menu when route changes
    useEffect(() => {
        setIsMobileMenuOpen(false);
    }, [location.pathname]);


    const toggleNavbarMode = () => {
        const newMode = navbarMode === "hardware" ? "software" : "hardware";
        setNavbarMode(newMode);
        localStorage.setItem("navbarmode", newMode);
    };

    const handleLogin = () => {
        setIsLoggedIn(!isLoggedIn);
    };

    return (
        <div className="navbar-container">
            <div className="header">
                <div className="head">
                    <h2>PC-Config</h2>
                </div>
                <marquee>
Services: PC and Server Building & Maintenance, OS and Software Installation, AMC Support, Web Hosting (Linux & Windows), Corporate Email Hosting, Unlimited Hosting, Website Development, Dedicated Servers, Domain Registration, and Server Management.
</marquee>


                <div className="nav-right">
                    <button 
                        onClick={toggleNavbarMode}
                        className="mode-toggle"
                    >
                        {navbarMode === 'hardware' ? 'Software Mode' : 'Hardware Mode'}
                    </button>

                    <div className="auth-section">
                        {isLoggedIn ? (
                            <div className="user-dropdown">
                                <span className="username">User</span>
                                <div className="dropdown-content">
                                    <a href="/profile">Profile</a>
                                    <a href="/settings">Settings</a>
                                    <button onClick={handleLogin} className="logout-btn">Logout</button>
                                </div>
                            </div>
                        ) : (
                            <button onClick={handleLogin} className="login-btn">Login</button>
                        )}
                    </div>

             
                </div>
            </div>

                        {/* Mobile Menu */}
                        <div    >
                <div className="navbar" >
                    {navbarMode === 'hardware' ? (
                        <>
                        <>
                            <a href="/hardware/home"        >Home</a>
                            <a href="/hardware/pc"    >PC Builder</a>
                            <a href="/hardware/laptop"    >Laptops</a>
                            <a href="/hardware/components"    >Components</a>
                            <a href="/hardware/networking"    >Networking</a>


                        </>
                        <div className="support-section">
                            <span>support:</span>
                            <span>mail: pcconfig@gmail.com</span>
                            <span>phone: 6381121261</span>
                        </div>
                        </>
                    ) : (
                        <> 
                        <>
                            <a href="/software/home"          >Home</a>
                            <a href="/software/products"    >Products</a>
                            <a href="/software/antivirus"    >Antivirus</a>
                            <a href="/software/tools"    >PC Tools</a>
                            <a href="/software/support"    >Support</a>
                        </>
                        <div className="support-section">
                            <span>support:</span>
                            <span>mail: pcconfig@gmail.com</span>
                            <span>phone: 6381121261</span>
                        </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Navbar;
